import { Injectable, InjectionToken, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

export interface BaseSEOData {
  title: string;
  description: string;
}

export const BASE_SEO_DATA = new InjectionToken<BaseSEOData>('BASE_SEO_DATA', {
  providedIn: 'root',
  factory: () => {
    const title = inject(Title);
    const meta = inject(Meta);
    
    const titleValue = title.getTitle() || '';
    const descriptionTag = meta.getTag('name="description"');
    const description = descriptionTag?.content || '';

    return { title: titleValue, description };
  }
});

@Injectable({
  providedIn: 'root'
})
export class SEOService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly baseSeoData = inject(BASE_SEO_DATA);

  getBaseSeoData(): BaseSEOData {
    return this.baseSeoData;
  }

  setTitle(newTitle: string | null | undefined): void {
    const baseTitle = this.baseSeoData.title;
    
    if (!newTitle) {
      // If new title is empty/null, use base title
      this.title.setTitle(baseTitle);
    } else {
      // If new title has value, combine with base title
      const finalTitle = baseTitle ? `${newTitle} | ${baseTitle}` : newTitle;
      this.title.setTitle(finalTitle);
    }
  }

  setDescription(newDescription: string | null | undefined): void {
    const baseDescription = this.baseSeoData.description;
    
    if (!newDescription) {
      // If new description is empty/null, use base description
      this.meta.updateTag({ name: 'description', content: baseDescription });
    } else {
      // If new description has value, replace base description
      this.meta.updateTag({ name: 'description', content: newDescription });
    }
  }
}